import {gql} from "@apollo/client";

export const GET_QUESTIONS_OVERVIEW = gql`
	query GetQuestionSetups(
		$stage: String
		$first: Int
		$after: String
		$where: QuestionSetupFilterInput
		$order: [QuestionSetupSortInput!]
	)
	{
		questionSetups(
			stage: $stage
			first: $first
			after: $after
			where: $where
			order: $order
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				fullId
				definition
				clientName
				frontEndName
				lastModifiedBy
				lastModifiedDateTime
			}
		}
	}
`;

export const GET_QUESTION_DETAILS = gql`
	query GetQuestionSetupDetails(
		$stage: String
		$definition: String
	)
	{
		questionSetups(
			stage: $stage
			where: {
				definition: {
					eq: $definition
				}
			}
			order: [
				{ clientName: ASC },
				{ frontEndName: ASC },
			]
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				fullId
				parameters
				extends
				definition
				frontEndName
				clientName
				name
				versionId
				label {
					isPresent
					value
				}
				subLabel {
					isPresent
					value
				}
				labelExpression
				subLabelExpression
				description {
					isPresent
					value
				}
				valueType {
					isPresent
					value
				}
				queryType {
					isPresent
					value
				}
				valueOptions {
					isPresent
					value {
						value
						display
						extraDisplay
						extraDisplayExpression
					}
				}
				unit {
					isPresent
					value
				}
				defaultValue {
					isPresent
					value
				}
				mapping {
					isPresent
					value
				}
				defaultPositioning {
					isPresent
					value {
						afterQuestion
					}
				}
				missingRequiredValueErrorMessage {
					isPresent
					value
				}
				valueMapping
				defaultValueExpression
				visibleExpression
				enabledExpression
				editableExpression
				requiredExpression
				validators
				custom {
					postback
				}
				rendererProperties
				id
				version
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;


export const GET_MULTIPLE_QUESTION_DETAILS = gql`
	query GetQuestionSetupDetails(
		$stage: String
		$definitions: [String]
	)
	{
		questionSetups(
			stage: $stage
			where: {
				definition: {
					in: $definitions
				}
			}
			order: [
				{ clientName: ASC },
				{ frontEndName: ASC },
			]
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				fullId
				parameters
				extends
				definition
				frontEndName
				clientName
				name
				versionId
				label {
					isPresent
					value
				}
				labelExpression
				description {
					isPresent
					value
				}
				valueType {
					isPresent
					value
				}
				queryType {
					isPresent
					value
				}
				valueOptions {
					isPresent
					value {
						value
						display
					}
				}
				unit {
					isPresent
					value
				}
				defaultValue {
					isPresent
					value
				}
				mapping {
					isPresent
					value
				}
				defaultPositioning {
					isPresent
					value {
						afterQuestion
					}
				}
				missingRequiredValueErrorMessage {
					isPresent
					value
				}
				valueMapping
				defaultValueExpression
				visibleExpression
				enabledExpression
				editableExpression
				requiredExpression
				validators
				custom {
					postback
				}
				rendererProperties
				id
				version
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

// todo assert that this is not paged
//  ^ or scan all pages
export const GET_QUESTION_DEFINITIONS = gql`
	query GetQuestionSetupDetails(
		$stage: String
	) {
		questionSetups(
			stage: $stage
			order: [
				{ definition: ASC },
			]
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				definition
			}
		}
	}
`;

export const PUT_QUESTION_SETUP = gql`
    mutation PutQuestionSetup(
		$stage: String
	    $questionSetup: QuestionSetupInput!
    ) {
        putQuestionSetup(
			stage: $stage
	        questionSetup: $questionSetup
        ) {
            fullId
        }
    }
`;

export const DELETE_QUESTION_SETUP = gql`
    mutation DeleteQuestionSetup(
	    $stage: String
		$questionDefinition: String!
		$frontEndName: String
		$clientName: String
    ) {
		deleteQuestionSetup(
			stage: $stage
			questionDefinition: $questionDefinition
			frontEndName: $frontEndName
			clientName: $clientName
		) {
            fullId
        }
    }
`;
